import CollapsibleSection from 'src/componentes/CollapsibleSection';
import { useIntl } from 'react-intl';
import { Row, Col } from 'src/componentes/grid';
import ControleLookup from 'src/lookups/ControleLookup';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';
import ItemOrganizacaoLookup from 'src/lookups/item-organizacao';
import Checkbox from 'src/componentes/checkbox';
import TipoPontoControle from 'src/lookups/tipo-ponto-controle';
import PeriodicidadeLookup from 'src/lookups/tipo-periodicidade-ponto-controle';
import TipoToleranciaLookup from 'src/lookups/tipo-tolerancia';
import InputNumber from 'src/componentes/input-number';
import FrequenciaControleLookup from 'src/lookups/frequencia-controle';
import FuncaoPontoControlelookup from 'src/lookups/funcao-pontocontrole';
import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';

function InformacoesControle({
  model,
  config,
  hideControlesFilter,
  searchQuery,
}) {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const { utilizarTipoPontoControle, frequenciaControle, funcaoPontoControle } =
    config ?? {};

  const showControlesFilters = !hideControlesFilter;

  const isVisible = (label) => matchesSearch(label, searchQuery);

  const labelControles = showControlesFilters
    ? capitalizeFirstLetter(resources?.pontosdecontrole)
    : null;
  const labelAreasControle = showControlesFilters
    ? intl.formatMessage(
        { id: 'areasDoControle' },
        { areas: resources?.areas, pontodecontrole: resources?.pontodecontrole }
      )
    : null;
  const labelAreasSubordinadasControle = intl.formatMessage(
    { id: 'label.considerarAreasSubordinadas' },
    { areas: resources?.areas }
  );
  const labelFrequenciaControle =
    frequenciaControle && showControlesFilters
      ? intl.formatMessage({ id: 'label.frequencia' })
      : null;
  const labelFuncaoPontoControle =
    funcaoPontoControle && showControlesFilters
      ? intl.formatMessage(
          { id: 'funcaoPontoControle' },
          { pontodecontrole: resources?.pontodecontrole }
        )
      : null;
  const labelPeriodicidade = showControlesFilters
    ? intl.formatMessage({ id: 'periodicidade' })
    : null;
  const labelTipoPontoControle =
    utilizarTipoPontoControle && showControlesFilters
      ? intl.formatMessage(
          { id: 'labelTipoPontoDeControle' },
          { pontodecontrole: resources?.pontodecontrole }
        )
      : null;
  const labelDiasTolerancia = showControlesFilters
    ? intl.formatMessage({ id: 'tolerancia' })
    : null;
  const labelTipoTolerancia = showControlesFilters
    ? intl.formatMessage({ id: 'tipoTolerancia' })
    : null;

  const allLabels = [
    labelControles,
    labelAreasControle,
    labelAreasSubordinadasControle,
    labelFrequenciaControle,
    labelFuncaoPontoControle,
    labelPeriodicidade,
    labelTipoPontoControle,
    labelDiasTolerancia,
    labelTipoTolerancia,
  ].filter(Boolean);

  if (searchQuery && !allLabels.some((l) => isVisible(l))) return null;

  return (
    <CollapsibleSection
      title={intl.formatMessage(
        { id: 'labelInformacaoControle' },
        { controle: resources?.pontodecontrole }
      )}
      defaultOpen={true}
      forceOpen={!!searchQuery}
    >
      <Row>
        {showControlesFilters && isVisible(labelControles) && (
          <Col md={12}>
            <ControleLookup
              multi
              clearable
              model={{
                label: labelControles,
                value: model.getModel('controles').value,
                requestChange: model.getModel('controles').requestChange,
              }}
            />
          </Col>
        )}
      </Row>
      <Row>
        {showControlesFilters && isVisible(labelAreasControle) && (
          <Col md={12}>
            <ItemOrganizacaoLookup
              multi={true}
              model={{
                label: capitalizeFirstLetter(labelAreasControle),
                value: model.getModel('areasControle').value,
                requestChange: model.getModel('areasControle').requestChange,
              }}
              data={{ tiposIdSelecionaveis: [1, 2, 3] }}
            />
          </Col>
        )}
        {showControlesFilters && isVisible(labelAreasSubordinadasControle) && (
          <Col md={12}>
            <Checkbox
              model={{
                label: labelAreasSubordinadasControle,
                value: model.getModel('areasSubordinadasControle').value,
                requestChange: model.getModel('areasSubordinadasControle')
                  .requestChange,
              }}
            />
          </Col>
        )}
        {frequenciaControle &&
          showControlesFilters &&
          isVisible(labelFrequenciaControle) && (
            <Col md={12} className="mt-3">
              <FrequenciaControleLookup
                model={{
                  label: labelFrequenciaControle,
                  value: model.getModel('frequenciaControle').value,
                  requestChange:
                    model.getModel('frequenciaControle').requestChange,
                }}
                clearable
              />
            </Col>
          )}
        {funcaoPontoControle &&
          showControlesFilters &&
          isVisible(labelFuncaoPontoControle) && (
            <Col md={12}>
              <FuncaoPontoControlelookup
                model={{
                  label: labelFuncaoPontoControle,
                  value: model.getModel('funcaoPontoControle').value,
                  requestChange: model.getModel('funcaoPontoControle')
                    .requestChange,
                }}
                clearable
              />
            </Col>
          )}
        <Col md={12}>
          {showControlesFilters && (
            <Row>
              {isVisible(labelPeriodicidade) && (
                <Col md={12}>
                  <PeriodicidadeLookup
                    clearable
                    model={model.getModel('periodicidade')}
                  />
                </Col>
              )}
              {utilizarTipoPontoControle &&
                isVisible(labelTipoPontoControle) && (
                  <Col md={12}>
                    <TipoPontoControle
                      clearable
                      model={{
                        label: labelTipoPontoControle,
                        value: model.getModel('tipoPontoControle').value,
                        requestChange:
                          model.getModel('tipoPontoControle').requestChange,
                      }}
                    />
                  </Col>
                )}
              {isVisible(labelDiasTolerancia) && (
                <Col md={12}>
                  <InputNumber model={model.getModel('diasTolerancia')} />
                </Col>
              )}
              {isVisible(labelTipoTolerancia) && (
                <Col md={12}>
                  <TipoToleranciaLookup
                    clearable
                    model={model.getModel('tipoTolerancia')}
                  />
                </Col>
              )}
            </Row>
          )}
        </Col>
      </Row>
    </CollapsibleSection>
  );
}

export default InformacoesControle;
